import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ImageCarousel from "components/misc/ImageCarousel";
import Header from "../components/headers/light.js";

import shopIconImageSrc from "images/shop-icon.svg";
import utilesImagenSrc from "images/utiles.png";
import materialesImagenSrc from "images/materiales.jpg";
//import ListUbication from "components/maps/ListUbication";
import comprasIconSrc from "images/compras.png"
import transportIconSrc from "images/microbus.png"
import shieldIconSrc from "images/shield-icon.svg"
import callcenterIconSrc from "images/centro-de-llamadas.png"
import utiles2ImgSrc from "images/utiles2.jpg"

import caru1ImgSrc from "images/caru1.jpeg"
import caru2ImgSrc from "images/caru2.jpeg"
import caru3ImgSrc from "images/caru3.jpeg"
import caru4ImgSrc from "images/caru4.jpeg"
import caru5ImgSrc from "images/caru5.jpeg"

import  FacebookIcon  from "images/facebook.png";
import  InstagramIcon from "images/instagram.png";
import  GmailIcon  from "images/gmail.png";
import  WhatsappIcon from "images/whatsapp.png"

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-[#1DA1F2] text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl`;

  // Estilo para las secciones para evitar que el header se oculte
  const SectionContainer = tw.section`relative scroll-mt-20`;

  // Datos para el carrusel
  const carouselImages = [
    {
      src: caru1ImgSrc,
      title: "Lápices",
      description: "Lápices, colores y más para estudiantes"
    },
    {
      src: caru2ImgSrc,
      title: "Crayones", 
      description: "Crayones de diferentes marcas"
    },
    {
      src: caru3ImgSrc,
      title: "Marcadores",
      description: "Distintos colores y tipos de marcadores"
    },
    {
      src: caru4ImgSrc,
      title: "Lapiceros",
      description: "Lapiceros de diferentes marcas y colores"
    },
    {
      src: caru5ImgSrc,
      title: "Utiles",
      description: "Diferentes utiles escolare y de oficina"
    }
  ];

  const emailConfig = {
    to: 'colibrilibreria2020@gmail.com',
    subject: 'Consulta desde la página web',
    body: 'Hola,\n\nMe gustaría obtener más información sobre sus productos.\n\nSaludos cordiales.'
  };

  const openGmailCompose = () => {
    const { to, subject, body } = emailConfig;
    
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);
    
    // URL específica de Gmail para compose
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${encodedSubject}&body=${encodedBody}`;
    
    // Abrir en nueva pestaña
    window.open(gmailUrl, '_blank');
  };

  return (
    <AnimationRevealPage>
      <Header />
      
      {/* Sección Hero con carrusel */}
      <section id="inicio">
        <ImageCarousel 
          images={carouselImages}
          autoplay={true}
          autoplaySpeed={2000}
          showDots={true}
          showArrows={true}
          slidesToShow={3}
        />
        <Hero
          heading={<>Utiles & Materiales <HighlightedText>Todo para tu oficina, en un solo vuelo.</HighlightedText></>}
          description="Somos una empresa guatemalteca dedicada a brindar soluciones prácticas y confiables en el suministro de artículos escolares y de oficina. En Colibrí, creemos que los pequeños detalles hacen grandes diferencias. Por eso, trabajamos con responsabilidad y pasión para ser su aliado confiable en cada etapa del año escolar y en las operaciones diarias de su empresa."
          imageSrc={materialesImagenSrc}
          imageCss={imageCss}
          imageDecoratorBlob={true}
          primaryButtonText="Ordena Ahora"
          videoVisible={false}
          primaryButtonUrl={"https://wa.me/50235991860"}
        />
      </section>

      {/* Sección Sobre Nosotros */}
      <SectionContainer id="sobre-nosotros">
        <MainFeature
          subheading={<Subheading>Establecido desde 2022</Subheading>}
          heading={
            <>
              Hemos estado sirviendo por
              <wbr /> <HighlightedText>más de 3 años.</HighlightedText>
            </>
          }
          description={
            <Description>
              Nos especializamos en la venta y distribución de artículos de oficina y escolares, todo lo necesario para equipar oficinas de manera eficiente.
              <br />
              <br />
               Atendemos a empresas, instituciones y público en general, adaptándonos a sus necesidades con un servicio personalizado, atención rápida y productos de alta calidad.
            </Description>
          }
          buttonRounded={false}
          textOnLeft={false}
          primaryButtonText="Latest Offers"
          imageSrc={utilesImagenSrc}
          imageCss={imageCss}
          imageDecoratorBlob={true}
          hidePrimaryButton={false}
          imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
        />
      </SectionContainer>

      {/* Sección Productos */}
      <SectionContainer id="productos">
        <TabGrid
          heading={
            <>
              Explora algunos <HighlightedText>artículos.</HighlightedText>
            </>
          }
        />
      </SectionContainer>

      {/* Sección Servicios */}
      <section id="servicios">
        <Features
          heading={
            <>
              Servicio <HighlightedText>Increible.</HighlightedText>
            </>
          }
          linkText={null}
          cards={[
            {
              imageSrc: shopIconImageSrc,
              title: "Tienda Fisica",
              description: "Puedes visitar nuestra sucursal.",
            },
            {
              imageSrc: comprasIconSrc,
              title: "Pedidos en linea",
              description: "Solicita tus productos o cotizaciones por whatsapp",
            },
            {
              imageSrc: transportIconSrc,
              title: "Entrega adomicilio",
              description: "Te entregamos tus productos en la oficina. Aplican restricciones",
            },
            {
              imageSrc: shieldIconSrc ,
              title: "Seguridad",
              description: "Todas sus compras son garatizadas y seguras",
            },
            {
              imageSrc: callcenterIconSrc ,
              title: "Atención personalizada ",
              description: "Nuestro equipo estara gustozo de atenderlos",
            }
          ]}
          imageContainerCss={tw`p-2!`}
          imageCss={tw`w-20! h-20!`}
        />
      </section>

      {/* Sección Por qué elegirnos */}
      <section id="por-que-elegirnos">
        <MainFeature2
          subheading={<Subheading> </Subheading>}
          heading={<>Porque <HighlightedText>Elegirnos?</HighlightedText></>}
          description="En Librería Colibrí no solo vendemos productos, construimos relaciones de confianza con cada cliente, cuidando hasta el ultimo detalle como si fuera propio."
          statistics={[
            {
              key: "Ordenes",
              value: "1000+",
            },
            {
              key: "Empresas",
              value: "15+"
            },
            {
              key: "Productos",
              value: "430+"
            }
          ]}
          primaryButtonText="Ordena ahora"
          primaryButtonUrl="https://wa.me/50235991860"
          imageInsideDiv={false}
          imageSrc={utiles2ImgSrc}
          imageCss={Object.assign(tw`bg-cover`, imageCss)}
          imageContainerCss={tw`md:w-1/2 h-auto`}
          imageDecoratorBlob={true}
          imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
          textOnLeft={true}
        />
      </section>

      {/* Sección Contacto */}
      {/*<SectionContainer id="contactenos">
        <ListUbication
          imageSrc={utilesImagenSrc}
          imageCss={imageCss}
          imageDecoratorBlob={true}
          imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
          textOnLeft={false}
        />
      </SectionContainer>*/}

      {/* Sección Redes Sociales */}
      <section id="redes-sociales">
        <Features
          heading={
            <>
              Siguenos en nuestras redes sociales.
            </>
          }
          description={""}
          linkText={null}
          cards={[
            {
              imageSrc: FacebookIcon,
              title: "Facebook",
              description: " ",
              url:"https://www.facebook.com/share/1F8LmzcN6L/"
            },
            {
              imageSrc: InstagramIcon,
              title: "Instagram",
              description: " ",
              url:"https://www.instagram.com/libreria_colibri_gt/"
            },
            {
              imageSrc: GmailIcon,
              title: "Gmail",
              description: " ",
              onClick: ()=>openGmailCompose()
            },
            {
              imageSrc: WhatsappIcon,
              title: "Whatsapp",
              description: " ",
              url:"https://wa.me/50235991860"
            },
          ]}
          imageContainerCss={tw`p-2!`}
          imageCss={tw`w-20! h-20!`}
        />
      </section>

      <Footer />
    </AnimationRevealPage>
  );
}